<template>
    <div
        class="safe-area-background"
        :class="[position, { 'w-full': show }]"
    />
</template>

<script
    setup
    lang="ts"
>
import { computed, PropType } from 'vue';
import { getCssPropertyAsNumber } from '../styles/css-properties.js';

const props = defineProps({
    position: {
        type: String as PropType<"top" | "bottom">,
        required: false,
        default: "top"
    }
});

const show = computed(() => {
    const hasTopArea = getCssPropertyAsNumber("--ion-safe-area-top") > 0;
    const hasBottomArea = getCssPropertyAsNumber("--ion-safe-area-bottom") > 0;
    return (props.position === "top" && hasTopArea) || (props.position === "bottom" && hasBottomArea);
});

</script>

<style scoped>
.safe-area-background {
    background: var(--safe-area-background-color, var(--primary, #511A3F));
}

.safe-area-background.top {
    height: var(--ion-safe-area-top, 0px);
}

.safe-area-background.bottom {
    height: var(--ion-safe-area-bottom, 0px);
}
</style>